export const FLAG_GETTING_DRIVER_TYPES = 'FLAG_GETTING_DRIVER_TYPES';
export const GET_DRIVER_TYPES = 'GET_DRIVER_TYPES';
export const CLEAR_DRIVER_TYPES = 'CLEAR_DRIVER_TYPES';
export const FLAG_DRIVER_TYPE_ACTIVITY = 'FLAG_DRIVER_TYPE_ACTIVITY';
export const GET_DRIVER_TYPE = 'GET_DRIVER_TYPE';
export const CLEAR_DRIVER_TYPE = 'CLEAR_DRIVER_TYPE';
